'use client';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import TrpcProviders from '@/app/_trpc/TrpcProviders';
import { DialogProvider } from '@/components/features/dialogs/infra/context/DialogContext';
import { SidebarProvider } from '@/components/ui/sidebar';
import { MenuProvider } from '@/context/MenuContext';
import { DesktopPushNotificationDialogProvider } from './push-notifications/context/DesktopPushNotificationDialogContext';
import { PushNotificationProvider } from './push-notifications/context/PushNotificationContext';
import SessionProviderWrapper from './SessionProviderWrapper';

export default function Provider({ children }: { children: React.ReactNode }) {
  return (
    <SessionProviderWrapper>
      <DialogProvider>
        <TrpcProviders>
          <SidebarProvider>
            <MenuProvider>
              <NuqsAdapter>
                <DesktopPushNotificationDialogProvider>
                  <PushNotificationProvider>
                    {children}
                  </PushNotificationProvider>
                </DesktopPushNotificationDialogProvider>
              </NuqsAdapter>
            </MenuProvider>
          </SidebarProvider>
        </TrpcProviders>
      </DialogProvider>
    </SessionProviderWrapper>
  );
}
